import { EditAction } from '../shared/enum/EditAction';

export interface ClientProductModel {
    id: number,
    clientId: number,
    productId: number,
    productDescription: string,
    userId: number,
    editAction: EditAction
}

export const clientProductModelInitial: ClientProductModel = {
    id: 0,
    clientId: 0,
    productId: 0,
    productDescription: '',
    userId: 0,
    editAction: EditAction.NONE
};